import React from 'react';

export const AIIcon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='42'
            height='42'
            viewBox='0 0 42 42'
            fill='none'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19.3398 12.0469C19.5942 12.047 19.8217 12.2073 19.9062 12.4473L25.9844 29.6875C26.0301 29.8176 25.9328 29.9551 25.7949 29.9551H23.0469C22.7891 29.9551 22.5586 29.7892 22.4766 29.5449L21.1309 25.5391H14.3984L13.0547 29.5449C12.9727 29.7892 12.744 29.955 12.4863 29.9551H9.73828C9.60036 29.9551 9.50303 29.8176 9.54883 29.6875L15.6191 12.4473C15.7036 12.2074 15.9293 12.0472 16.1836 12.0469H19.3398ZM17.7617 15.7188C17.72 15.7188 17.6832 15.7456 17.6699 15.7852L15.2734 22.9316H20.2539L17.8535 15.7852C17.8402 15.7455 17.8035 15.7188 17.7617 15.7188Z'
                fill='#6257D2'
            />
            <path
                d='M29.9863 12.0469C30.3176 12.047 30.5859 12.3152 30.5859 12.6465V29.3535C30.5859 29.6848 30.3176 29.953 29.9863 29.9531H27.9414C27.6103 29.9528 27.3418 29.6847 27.3418 29.3535V12.6465C27.3418 12.3153 27.6103 12.0472 27.9414 12.0469H29.9863Z'
                fill='#6257D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21 0C32.5969 0 42 9.40313 42 21C42 32.5969 32.5969 42 21 42C9.40313 42 0 32.5969 0 21C0 9.40313 9.40313 0 21 0ZM21 3.5625C11.3719 3.5625 3.5625 11.3719 3.5625 21C3.5625 30.6281 11.3719 38.4375 21 38.4375C30.6281 38.4375 38.4375 30.6281 38.4375 21C38.4375 11.3719 30.6281 3.5625 21 3.5625Z'
                fill='#6257D2'
            />
        </svg>
    );
};
